<div class="header-wrapper">
  <div class="powered-by">{{ 'header.powered_by' | translate }}</div>
  <div class="separator"></div>
  <div class="img-wrapper mr--3">
    @if (logo(); as logoSrc) {
      <img class="logo" [src]="logoSrc" [alt]="logoSrc"/>
    }
  </div>
  <app-lang-menu class="hidden sm_block"></app-lang-menu>
  <ng-content></ng-content>
</div>
